import {useQuery} from "@tanstack/react-query";
import axios from "axios";
import {useIsAuthenticated} from "./authentication/authenticationQueries";

import {type Context, ContextSchema} from "@mytour/shared";
import type {SafeParseError} from "zod";
const keysStore = {
  root: ["context"] as const,
  getContext: () => [...keysStore.root] as const,
};

export function useContext() {
  const {isAuthenticated} = useIsAuthenticated();
  const {
    data: context,
    isLoading,
    isFetching,
    refetch,
    error,
  } = useQuery({
    queryKey: keysStore.getContext(),
    queryFn: contextApiService.getContext,
    enabled: isAuthenticated,
    refetchOnWindowFocus: false,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });

  return {
    context,
    isContextLoading: isLoading,
    isContextFetching: isFetching,
    contextError: error,
    refetchContext: refetch,
  };
}

const contextApiService = {
  async getContext(): Promise<Context> {
    const response = await axios.get("api/context");
    const validationResult = ContextSchema.safeParse(response.data);
    if (!validationResult.success) {
      const error = (validationResult as SafeParseError<Context>).error;
      throw new Error(`Invalid context data: ${error.message}`);
    }
    return validationResult.data;
  },
};
